import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import Card from "../../components/card";
import Button from "../../components/button";
import {FaFileExcel, FaPlusSquare} from "react-icons/fa";
import InputForm from "../../components/input-form";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../utils/localization-ag-grid";
import TemplateDefault from "../../components/template-default";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css"
import {useQuery} from "@tanstack/react-query";
import userService from "../../services/user-service";
import {useNavigate} from "react-router-dom";
import phoneRender from "../dashboard/components/phone-render";
import general from "../../utils/general";
import cpfRender from "./components/cpf-render";
import {buildAccentInsensitiveColDef, setAccentInsensitiveQuickFilter} from "../../utils/ag-grid-quick-filter";

const Users = () => {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "SISTEMA INTERNO";
    }, []);

    const {data: users} = useQuery({
        queryFn: () => userService.list().then(({data}) => data),
        queryKey: ['users']
    });

    const [columnDefs] = useState([
        {field: "id", headerName: "ID", width: 40},
        {field: "name", headerName: "Nome"},
        {field: "cpf", headerName: "CPF", flex: 1, minWidth: 200, cellRenderer: cpfRender},
        {field: "login", headerName: "Login", flex: 1, minWidth: 200},
        {field: "project", headerName: "Projeto", flex: 2, minWidth: 250},
        {field: "resale", headerName: "Revenda", flex: 2, minWidth: 250},
        {field: "phone", headerName: "Telefone", cellRenderer: phoneRender, flex: 1, minWidth: 200},
        {field: "email", headerName: "E-mail", flex: 1, minWidth: 200},
    ]);

    const gridRef = useRef();

    const defaultColDef = useMemo(() => {
        return buildAccentInsensitiveColDef({resizable: false});
    }, []);

    const onFilterTextBoxChanged = useCallback(({target}) => {
        setAccentInsensitiveQuickFilter(gridRef, target.value);
    }, []);


    const onCellClicked = (cell) => {
        if (cell.colDef.field !== "phone") navigate(`/users/form/${cell.data.id}`)
    };

    const exportLicensing = () => {
        const newArray = users.map(data =>
            ({
                "ID": data.id,
                "Nome": data.name,
                "Login": data.login,
                "Projeto": data.project,
                "Revenda": data.resale,
                "Telefone": data.phone?.replace(/^(\d{2})(\d{4,5})(\d{4})$/, "($1) $2-$3"),
                "E-mail": data.email,
            })
        );

        general.exportCsv(newArray);
    }

    return (
        <TemplateDefault title="Usuários">
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <Button col="col-span-2" onClick={() => navigate("/users/form")}>
                        <FaPlusSquare/> Novo usuário
                    </Button>

                    <InputForm id="search" col="col-span-9" label="Pesquisar" type="search"
                               onChange={onFilterTextBoxChanged}/>

                    <Button target="success" onClick={exportLicensing} col="col-span-1 !h-[32px]">
                        <FaFileExcel />
                    </Button>
                </div>

                <div className={"ag-theme-quartz grid mt-4"} style={{height: "calc(100vh - 185px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={users}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        pagination
                        paginationPageSize={500}
                        paginationPageSizeSelector={[10, 50, 100, 500]}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        gridOptions={{localeText: LocalizationAgGrid}}
                        onCellClicked={onCellClicked}
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default Users;
